module.exports = __webpack_public_path__ + "static/img/12一种便于移动具有烘干功能的凹版印花机.2769257b.jpg";